// extracted by mini-css-extract-plugin
export default {"label":"label-module___label___de419b4a"};